<template>
  <div class="container">
    <div class="title">
      <h4>Задачи </h4>
    </div>
    <div class="content" v-loading="loading">
      <div class="controls">
        <custom-cascader-category
            :multipart="false"
            :propsGetSelectedCategoryAndEmployee="getSelectedCategoryAndEmployee"
        />
        <custom-date-range-picker-for-employee-interaction
            :propsGetSelectedDate="getSelectedDate"
        />
        <div class="button_get_block">
          <el-button
              class="button_get"

              type="primary"
              @click="getAnswers"
          >
            получить
          </el-button>
        </div>

      </div>
      <div class="separator"></div>
      <div class="info">
        <div class="calls">
          <div v-for="(call, index) in calls"  @click="()=>{openDrawerCallInfo(call.call_id)}" class="callItem">
            <div class="flex">
              <p>Звонок: <span>{{ call.call_id }}</span></p>
              <p>Дата звонка: <span>{{ call.date_call.replace('T', " ").replace('Z', '') }}</span></p>
            </div>
            <p v-if="whatAreTheResultsOfTheConversation(call)">
              Суть звонка:<span> {{
              whatAreTheResultsOfTheConversation(call)
              }}</span>
            </p>
            <p v-if="  theResultOFTheConversation(call)">
              Что должен сделать менеджер :<span> {{
                theResultOFTheConversation(call)
              }}</span>
            </p>
          </div>

        </div>
      </div>


    </div>
    <el-drawer
        :style="{display:stateDrawer?'flex':'none'}"
        title="I am the title"
        :visible.sync="stateDrawer"
        :with-header="false"
        size="95%"
    >
      <drawer-call-info
          :categoryName="'---'"
          :dateCall="'--'"
          :clientNumber="''"
          :clientName="''"
          :stateDrawer="stateDrawer"
          :callId="callId"
          :period="{start: null, end: null}"
      />
    </el-drawer>

  </div>
</template>

<script>


import CustomSelectChecklist
  from "@/components/analytics/employeeInteraction/customSelectChecklist.vue";
import CustomCascaderCategory
  from "@/components/analytics/employeeInteraction/customCascaderCategory.vue";
import CustomDateRangePickerForEmployeeInteraction
  from "@/components/analytics/employeeInteraction/customDateRangePickerForEmployeeInteraction.vue";
import DrawerCallInfo from "@/components/newCatigories/drawerCallInfo.vue";
import MySpinner from "@/components/UI/MySpinner.vue";
import login from "@/views/auth/Login.vue";

export default {
  components: {
    MySpinner,
    DrawerCallInfo,
    CustomSelectChecklist,
    CustomCascaderCategory,
    CustomDateRangePickerForEmployeeInteraction
  },

  data() {
    return {
      blockBTNGetAnswer: true,
      loading: false,
      loadingSpinner: false,
      calls: [],
      stateDrawer:false,
      start: null,
      end: null,
      callId: null,
      dataToSend: {
        date_call: [],
        category_id: null,
        manager: null,
        org_id: this.$store.getters.user.organization_id,

      },
      categoryName: null,
    };
  },
  methods: {
    openDrawerCallInfo(call_id) {
    console.log("openDrawerCallInfo", call_id);
    this.callId=call_id;
    this.stateDrawer = true;
    },

    getSelectedDate(value) {


      this.dataToSend['date_call'] = value
    },
    getSelectedCategoryAndEmployee(value) {
      this.dataToSend['category_id'] = [value['category']]
      this.dataToSend['manager'] = [value['employee']]
    },

    async sendRequest() {
      const from = new Date(this.dataToSend['date_call'][0]);
      const to = new Date(this.dataToSend['date_call'][1]);

      function format(dateObj, time = '00:00:00') {
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${time}`;
      }

      const value_from = format(from, '00:00:00');
      const value_to = format(to, '23:59:59');
      const userOrgId = this.$store.state.user.organization_id;

      this.dataToSend['date_call'] = [value_from, value_to]
      this.dataToSend['org_id']=userOrgId
      this.getTasks(this.dataToSend).then((data)=>{
        this.blockBTNGetAnswer = true
       if (data.success) {
         console.log(data)
         this.calls = data.data
       }
      }).finally(()=>{
        this.blockBTNGetAnswer = false
     })
     //  await this.$api.ollama.getTaskManager(this.dataToSend).then((response) => {
     //     this.blockBTNGetAnswer = true
     //    if (response) {
     //      this.calls = response
     //    }
     //  }).finally(()=>{
     //    this.blockBTNGetAnswer = false
     //  })
    },
    getTasks(data_to_send) {
      const jwt = localStorage.getItem("access_token");
      const userOrgId = this.$store.state.user.organization_id;

      return fetch(
        'https://pro.evrika360.com/integrations/ollama/v1/front-dashboard/tasks',
        {
          method: 'POST',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${jwt}`,
          },
          body: JSON.stringify(data_to_send),
        }
      )
        .then((response) => {
          if (!response.ok) {
            return response.text()
              .catch(() => '')
              .then((errorText) => {
                throw new Error(`HTTP ${response.status}: ${errorText || response.statusText}`);
              });
          }
          return response.json();
        });
    },

    getAnswers() {
      this.sendRequest()
    },
    theResultOFTheConversation(data) {
      try {
        return data?.answers?.system[0]?.result['информация_по_менеджеру']['что_должен_сделать_менеджер']
      } catch {
        return ""
      }
    },
    whatAreTheResultsOfTheConversation(data) {
      try {
        return  data?.answers?.system[0]?.result['информация_по_звонку']['суть_звонка']
      } catch {
        return ""
      }
    }


  },

  computed: {},
  watch: {
    dataToSend: {
      handler() {
        if (
            this.dataToSend.org_id &&
            this.dataToSend.category_id &&
            this.dataToSend.manager &&
            this.dataToSend.date_call.length === 2
        ) {
          return this.blockBTNGetAnswer = false
        }
        return this.blockBTNGetAnswer = true
      },
      deep: true
    }

  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 15px;

  .content {

    padding: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    border-radius: 10px;
    background: #fff;
    min-height: 75vh;

    .title {
      margin-bottom: 30px;

      h4 {
        margin-bottom: 0;
        font-size: 18px;
        font-weight: 700;
        color: #555;

        span {
          font-weight: normal;
          font-size: 14px;
        }
      }
    }

    .controls {
      width: 100%;
      display: grid;
      grid-template-columns: 2fr 1fr 1fr;
      gap: 40px;
    }

    .disabled {
      opacity: 0.3;
      pointer-events: none;
    }

    .info {

    }


  }
}

.pointer {
  cursor: pointer;
}

.separator {
  margin: 5px 0;
  height: 1px;
  background: #b5b5b5;
  width: 100%;
}

.button_get_block {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;

  .button_get {
    width: 80%;
    margin-bottom: 6px;
    height: 21px;
    font-size: 10px !important;
  }
}

.callItem {
  margin-top: 10px;
  border: solid 1px #bebebe;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
  &:hover{
    border-color: #24387f;
  }


  p {
    margin-bottom: 0;

    span {
      color: #555;
    }

    &:nth-child(3) {
      font-weight: bold;
    }
  }
}

.flex {
  display: flex;
  gap: 20px;
}

</style>
